import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ServiceCategory } from '../../types';

interface ServiceCardProps {
  service: ServiceCategory;
  index: number;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service, index }) => {
  const Icon = service.icon;

  return (
    <div 
      className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:translate-y-[-4px]"
      style={{ 
        transitionDelay: `${index * 100}ms`
      }}
    >
      <div className="w-16 h-16 bg-success/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-success/20 transition-colors">
        {Icon && <Icon className="h-8 w-8 text-success group-hover:scale-110 transition-transform" />}
      </div>
      <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
      <p className="text-gray-600 mb-6 leading-relaxed">{service.subtitle}</p>
      <ul className="space-y-2 mb-6">
        {service.items[0].details.map((detail, idx) => (
          <li key={idx} className="flex items-start text-gray-600">
            <div className="w-1.5 h-1.5 bg-success rounded-full mr-2 flex-shrink-0 mt-2.5" />
            <div className="flex-grow">
              {detail}
            </div>
          </li>
        ))}
      </ul>
      <Link
        to={`/services#${service.id}`}
        className="text-success hover:text-dark font-medium inline-flex items-center group/link"
      >
        Mehr erfahren
        <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover/link:translate-x-1" />
      </Link>
    </div>
  );
};

export default ServiceCard;